import TabScrollButton from './TabScrollButton'
export default TabScrollButton
export * from './TabScrollButton'
